"use strict";
var Object3D_1 = require('./Object3D');
var types_1 = require('./types');
var DURATION = 1000;
var EffectManager = (function () {
    function EffectManager() {
        this.effects = [];
    }
    EffectManager.prototype.add = function (x, y, z, vao) {
        var object = new Object3D_1.default(vao, types_1.ShaderType.SPRITE);
        object.setPosition(x, y, z);
        this.effects.push({
            object: object,
            timer: DURATION,
        });
        return object;
    };
    EffectManager.prototype.tick = function (delta) {
        for (var i = this.effects.length - 1; i >= 0; --i) {
            var effect = this.effects[i];
            if (effect.timer < delta) {
                this.effects.splice(i, 1);
                continue;
            }
            effect.timer -= delta;
            effect.object.translateY(delta / DURATION * 0.7);
        }
    };
    return EffectManager;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EffectManager;
//# sourceMappingURL=EffectManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/EffectManager.js
 ** module id = 906
 ** module chunks = 0
 **/